import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectExternalProviderSpeakerResumeUpload = createSelector(
  [(state: AppState) => state.externalProvider.speakerResumeUpload],
  state => state,
);
